<template>

    <!-- <div >
        <div class="divider-vertical" style="height: 100vmax;"></div>
    </div> -->

    <div class="row g-32 mm-none " style="position: fixed; top: 20px; width: 23%;" >

        <!-- <button @click="pp">pppppppppp</button> -->

        <ul class="nav nav-tabs mb-12" id="pills-tab" role="tablist" >
            <li class="nav-item" role="presentation">
                <h6 style="padding-bottom: 10px;" class="nav-link active" id="pills-featured-tab" data-bs-toggle="pill" data-bs-target="#featured" type="button" role="tab" aria-controls="pills-featured" aria-selected="true">Featured</h6>
            </li>
            <li class="nav-item" role="presentation">
                <h6 style="padding-bottom: 10px;" class="nav-link" id="pills-popular-tab" data-bs-toggle="pill" data-bs-target="#popular" type="button" role="tab" aria-controls="pills-popular" aria-selected="false">Popular</h6>
            </li>
            <li class="nav-item" role="presentation">
                <h6 style="padding-bottom: 10px;" class="nav-link" id="pills-new-tab" data-bs-toggle="pill" data-bs-target="#new" type="button" role="tab" aria-controls="pills-new" aria-selected="false">New</h6>
            </li>
            
        </ul>

        <!-- <p>Spotlight on some awesome people you should know</p> -->

        <div class="tab-content" id="featuredTabContent" style="padding: 0 !important; margin: 0 !important;">

            <!-- FEATURED -->
            <div class="tab-pane fade show active" id="featured" role="tabpanel" aria-labelledby="featured-tab" style="margin-top: -10px;">
                
                <div id="carouselExampleIndicators" style="margin-top: -5px; padding: 0; background: transparent !important;" class="carousel slide " data-bs-ride="carousel" data-bs-touch="true" data-bs-interval="false" >

                    <div class="carousel-inner " style="margin-top: 10px; margin-bottom:50px; background: transparent; ">

                        <div class="card hp-card-9 " v-if="featuredObj == ''" style="width: 100%; display: flex; justify-content: center; align-items: center; border-color: #c3c3c3; border-width: 1px; border-style: solid; margin-top: 15px;">
                            <div class="spinner-border" role="status" >
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>

                        <div v-else class="carousel-item active" style="padding: 0; background: transparent; cursor: pointer;">

                            <div class="card hp-card-9 " style="margin-top: 15px; position: relative; background: transparent;" @click="profileClick(featuredObj.userId, featuredObj.userName)">

                                <img   :src="featuredObj.profilePic" alt="" style="z-index: 2; object-fit: cover; position: absolute; top: 0; bottom: 0; border-radius: 15px; width: 100%; height: 100%; left: 0;">

                                <div style="margin-top: 0px; position: absolute; bottom: 0px; z-index: 2; width: 100%; padding: 20px;" class="card-overlay3">

                                    <div class="w-auto m mt-12">

                                        <div style="display: flex; justify-content: flex-start; align-items: center;">

                                            <span class="d-block hp-text-color-black-0 hp-text-color-dark-0 hp-p1-body lh-1" style="font-size: 14px; max-width: 150px; font-weight: 500; font-family: 'Clash Display', sans-serif; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; text-align: start;"> {{ featuredObj.fullName }} 
                                            </span>

                                            <span v-if="featuredObj.userType == 'model'">
                                                <img src="@/assets/img/check-circle.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="featuredObj.sexuality == 'gay'">
                                                <img src="@/assets/img/gay.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="featuredObj.sexuality == 'lesibian'">
                                                <img src="@/assets/img/lesibian.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="featuredObj.sexuality == 'bisexual'">
                                                <img src="@/assets/img/bisexual.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                        </div>

                                        <p style="font-size: 12px; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; max-width: 150px;" class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4"> @{{ featuredObj.userName }} </p>

                                    </div>


                                </div>

                            </div>

                        </div>

                        <div class="carousel-item" style="padding: 0; background: transparent; cursor: pointer;" v-for="featured in featuredList" :key="featured.id" >


                            <div class="card hp-card-9 " style="margin-top: 15px; position: relative; background: transparent;" @click="profileClick(featured.userId, featured.userName)" >

                                <img   :src="featured.profilePic" alt="" style="z-index: 2; object-fit: cover; position: absolute; top: 0; bottom: 0; border-radius: 15px; width: 100%; height: 100%; left: 0;">

                                <div style="margin-top: 0px; position: absolute; bottom: 0px; z-index: 2; width: 100%; padding: 20px;" class="card-overlay3">

                                    <div class="w-auto m mt-12">

                                        <div style="display: flex; justify-content: flex-start; align-items: center;">

                                            <span class="d-block hp-text-color-black-0 hp-text-color-dark-0 hp-p1-body lh-1" style="font-size: 14px; max-width: 150px; font-weight: 500; font-family: 'Clash Display', sans-serif; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; text-align: start;"> {{ featured.fullName }}
                                            </span>

                                            <span v-if="featured.userType == 'model'">
                                                <img src="@/assets/img/check-circle.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="featured.sexuality == 'gay'">
                                                <img src="@/assets/img/gay.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="featured.sexuality == 'lesibian'">
                                                <img src="@/assets/img/lesibian.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="featured.sexuality == 'bisexual'">
                                                <img src="@/assets/img/bisexual.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                        </div>

                                        <p style="font-size: 12px; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; max-width: 150px;" class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4"> @{{ featured.userName }} </p>

                                    </div>


                                </div>

                            </div>

                            

                        </div>

                    </div>

                    <div class="carousel-indicators" >
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1">
                        </button>
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2">
                        </button>

                        <button v-if="featuredList.length == 2" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3">
                        </button>

                        <button  v-if="featuredList.length == 3" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4">
                        </button>

                        <button  v-if="featuredList.length == 4" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5">
                        </button>

                        <button  v-if="featuredList.length == 5" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Slide 6">
                        </button>

                        <button  v-if="featuredList.length == 6" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="6" aria-label="Slide 7">
                        </button>

                        <button  v-if="featuredList.length == 7" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="7" aria-label="Slide 8">
                        </button>

                        <button  v-if="featuredList.length == 8" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="8" aria-label="Slide 9">
                        </button>
                    </div>

                    <button class="carousel-control-prev btn btn-icon-only rounded-circle" type="button"
                                    data-bs-target="#carouselExampleIndicators" data-bs-slide="prev"
                                    style="margin-left: 20px; margin-bottom: 8px; background-color: transparent;">
                                    <i class="hp-text-color-dark-0 iconly-Light-ChevronLeftCircle" style="color: #9146ff;"></i>
                    </button>

                    <button class="carousel-control-next btn btn-icon-only rounded-circle" type="button"
                                    data-bs-target="#carouselExampleIndicators" data-bs-slide="next"
                                    style="margin-right: 20px; margin-bottom: 8px; background-color: transparent;">
                                    <i class="hp-text-color-dark-0 iconly-Light-ChevronRightCircle" style="color: #9146ff;"></i>
                    </button>

                                
                </div>
        
            </div>

            <!-- POPULAR -->
            <div class="tab-pane fade show" id="popular" role="tabpanel" aria-labelledby="popular-tab" style="margin-top: -10px;" >
                
                <div id="carouselExampleIndicators2" style="margin-top: -5px; padding: 0; background: transparent !important;" class="carousel slide " data-bs-ride="carousel" data-bs-touch="true" data-bs-interval="false" >

                    <div class="carousel-inner " style="margin-top: 10px; margin-bottom:50px; background: transparent; ">

                        <div class="card hp-card-9 " v-if="popularObj == ''" style="width: 100%; display: flex; justify-content: center; align-items: center; border-color: #c3c3c3; border-width: 1px; border-style: solid; margin-top: 15px;">
                            <div class="spinner-border" role="status" >
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>

                        <div v-else class="carousel-item active" style="padding: 0; background: transparent; cursor: pointer;">

                            <div class="card hp-card-9 " style="margin-top: 15px; position: relative; background: transparent;" @click="profileClick(popularObj.userId, popularObj.userName)">

                                <img   :src="popularObj.profilePic" alt="" style="z-index: 2; object-fit: cover; position: absolute; top: 0; bottom: 0; border-radius: 15px; width: 100%; height: 100%; left: 0;">

                                <div style="margin-top: 0px; position: absolute; bottom: 0px; z-index: 2; width: 100%; padding: 20px;" class="card-overlay3">

                                    <div class="w-auto m mt-12">

                                        <div style="display: flex; justify-content: flex-start; align-items: center;">

                                            <span class="d-block hp-text-color-black-0 hp-text-color-dark-0 hp-p1-body lh-1" style="font-size: 14px; max-width: 150px; font-weight: 500; font-family: 'Clash Display', sans-serif; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; text-align: start;"> {{ popularObj.fullName }} 
                                            </span>

                                            <span v-if="popularObj.userType == 'model'">
                                                <img src="@/assets/img/check-circle.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="popularObj.sexuality == 'gay'">
                                                <img src="@/assets/img/gay.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="popularObj.sexuality == 'lesibian'">
                                                <img src="@/assets/img/lesibian.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="popularObj.sexuality == 'bisexual'">
                                                <img src="@/assets/img/bisexual.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                        </div>

                                        <p style="font-size: 12px; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; max-width: 150px;" class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4"> @{{ popularObj.userName }} </p>

                                    </div>


                                </div>

                            </div>

                        </div>

                        <div class="carousel-item" style="padding: 0; background: transparent; cursor: pointer;" v-for="featured in popularList" :key="featured.id" >


                            <div class="card hp-card-9 " style="margin-top: 15px; position: relative; background: transparent;" @click="profileClick(featured.userId, featured.userName)" >

                                <img   :src="featured.profilePic" alt="" style="z-index: 2; object-fit: cover; position: absolute; top: 0; bottom: 0; border-radius: 15px; width: 100%; height: 100%; left: 0;">

                                <div style="margin-top: 0px; position: absolute; bottom: 0px; z-index: 2; width: 100%; padding: 20px;" class="card-overlay3">

                                    <div class="w-auto m mt-12">

                                        <div style="display: flex; justify-content: flex-start; align-items: center;">

                                            <span class="d-block hp-text-color-black-0 hp-text-color-dark-0 hp-p1-body lh-1" style="font-size: 14px; max-width: 150px; font-weight: 500; font-family: 'Clash Display', sans-serif; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; text-align: start;"> {{ featured.fullName }}
                                            </span>

                                            <span v-if="featured.userType == 'model'">
                                                <img src="@/assets/img/check-circle.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="featured.sexuality == 'gay'">
                                                <img src="@/assets/img/gay.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="featured.sexuality == 'lesibian'">
                                                <img src="@/assets/img/lesibian.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="featured.sexuality == 'bisexual'">
                                                <img src="@/assets/img/bisexual.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                        </div>

                                        <p style="font-size: 12px; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; max-width: 150px;" class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4"> @{{ featured.userName }} </p>

                                    </div>


                                </div>

                            </div>

                            

                        </div>

                    </div>

                    <div class="carousel-indicators" >
                        <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1">
                        </button>
                        <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="1" aria-label="Slide 2">
                        </button>

                        <button v-if="popularList.length >= 2" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3">
                        </button>

                        <button  v-if="popularList.length >= 3" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4">
                        </button>

                        <button  v-if="popularList.length >= 4" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="4" aria-label="Slide 5">
                        </button>

                        <button  v-if="popularList.length >= 5" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="5" aria-label="Slide 6">
                        </button>

                        <button  v-if="popularList.length >= 6" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="6" aria-label="Slide 7">
                        </button>

                        <button  v-if="popularList.length >= 7" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="7" aria-label="Slide 8">
                        </button>

                        <button  v-if="popularList.length >= 8" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="8" aria-label="Slide 9">
                        </button>

                        <button  v-if="popularList.length >= 9" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="9" aria-label="Slide 10">
                        </button>
                    </div>

                    <button class="carousel-control-prev btn btn-icon-only rounded-circle" type="button"
                                    data-bs-target="#carouselExampleIndicators2" data-bs-slide="prev"
                                    style="margin-left: 20px; margin-bottom: 8px; background-color: transparent;">
                                    <i class="hp-text-color-dark-0 iconly-Light-ChevronLeftCircle" style="color: #9146ff;"></i>
                    </button>

                    <button class="carousel-control-next btn btn-icon-only rounded-circle" type="button"
                                    data-bs-target="#carouselExampleIndicators2" data-bs-slide="next"
                                    style="margin-right: 20px; margin-bottom: 8px; background-color: transparent;">
                                    <i class="hp-text-color-dark-0 iconly-Light-ChevronRightCircle" style="color: #9146ff;"></i>
                    </button>

                                
                </div>

            </div>

            <!-- NEW -->
            <div class="tab-pane fade show" id="new" role="tabpanel" aria-labelledby="new-tab" style="margin-top: -10px;" >
                
                <div id="carouselExampleIndicators3" style="margin-top: -5px; padding: 0; background: transparent !important;" class="carousel slide " data-bs-ride="carousel" data-bs-touch="true" data-bs-interval="false" >

                    <div class="carousel-inner " style="margin-top: 10px; margin-bottom:50px; background: transparent; ">

                        <div class="card hp-card-9 " v-if="newObj == ''" style="width: 100%; display: flex; justify-content: center; align-items: center; border-color: #c3c3c3; border-width: 1px; border-style: solid; margin-top: 15px;">
                            <div class="spinner-border" role="status" >
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>

                        <div v-else class="carousel-item active" style="padding: 0; background: transparent; cursor: pointer;">

                            <div class="card hp-card-9 " style="margin-top: 15px; position: relative; background: transparent;" @click="profileClick(newObj.userId, newObj.userName)">

                                <img   :src="newObj.profilePic" alt="" style="z-index: 2; object-fit: cover; position: absolute; top: 0; bottom: 0; border-radius: 15px; width: 100%; height: 100%; left: 0;">

                                <div style="margin-top: 0px; position: absolute; bottom: 0px; z-index: 2; width: 100%; padding: 20px;" class="card-overlay3">

                                    <div class="w-auto m mt-12">

                                        <div style="display: flex; justify-content: flex-start; align-items: center;">

                                            <span class="d-block hp-text-color-black-0 hp-text-color-dark-0 hp-p1-body lh-1" style="font-size: 14px; max-width: 150px; font-weight: 500; font-family: 'Clash Display', sans-serif; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; text-align: start;"> {{ newObj.fullName }} 
                                            </span>

                                            <span v-if="newObj.userType == 'model'">
                                                <img src="@/assets/img/check-circle.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="newObj.sexuality == 'gay'">
                                                <img src="@/assets/img/gay.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="newObj.sexuality == 'lesibian'">
                                                <img src="@/assets/img/lesibian.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="newObj.sexuality == 'bisexual'">
                                                <img src="@/assets/img/bisexual.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                        </div>

                                        <p style="font-size: 12px; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; max-width: 150px;" class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4"> @{{ newObj.userName }} </p>

                                    </div>


                                </div>

                            </div>

                        </div>

                        <div class="carousel-item" style="padding: 0; background: transparent; cursor: pointer;" v-for="featured in newList" :key="featured.id" >


                            <div class="card hp-card-9 " style="margin-top: 15px; position: relative; background: transparent;" @click="profileClick(featured.userId, featured.userName)" >

                                <img   :src="featured.profilePic" alt="" style="z-index: 2; object-fit: cover; position: absolute; top: 0; bottom: 0; border-radius: 15px; width: 100%; height: 100%; left: 0;">

                                <div style="margin-top: 0px; position: absolute; bottom: 0px; z-index: 2; width: 100%; padding: 20px;" class="card-overlay3">

                                    <div class="w-auto m mt-12">

                                        <div style="display: flex; justify-content: flex-start; align-items: center;">

                                            <span class="d-block hp-text-color-black-0 hp-text-color-dark-0 hp-p1-body lh-1" style="font-size: 14px; max-width: 150px; font-weight: 500; font-family: 'Clash Display', sans-serif; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; text-align: start;"> {{ featured.fullName }}
                                            </span>

                                            <span v-if="featured.userType == 'model'">
                                                <img src="@/assets/img/check-circle.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="featured.sexuality == 'gay'">
                                                <img src="@/assets/img/gay.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="featured.sexuality == 'lesibian'">
                                                <img src="@/assets/img/lesibian.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                            <span v-if="featured.sexuality == 'bisexual'">
                                                <img src="@/assets/img/bisexual.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -5px;">
                                            </span>

                                        </div>

                                        <p style="font-size: 12px; color: #fff; text-overflow: ellipsis; white-space: nowrap;overflow: hidden; max-width: 150px;" class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4"> @{{ featured.userName }} </p>

                                    </div>


                                </div>

                            </div>

                            

                        </div>

                    </div>

                    <div class="carousel-indicators" >
                        <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1">
                        </button>
                        <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="1" aria-label="Slide 2">
                        </button>

                        <button v-if="newList.length >= 2" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="2" aria-label="Slide 3">
                        </button>

                        <button  v-if="newList.length >= 3" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="3" aria-label="Slide 4">
                        </button>

                        <button  v-if="newList.length >= 4" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="4" aria-label="Slide 5">
                        </button>

                        <button  v-if="newList.length >= 5" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="5" aria-label="Slide 6">
                        </button>

                        <button  v-if="newList.length >= 6" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="6" aria-label="Slide 7">
                        </button>

                        <button  v-if="newList.length >= 7" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="7" aria-label="Slide 8">
                        </button>

                        <button  v-if="newList.length >= 8" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="8" aria-label="Slide 9">
                        </button>

                        <button  v-if="newList.length >= 9" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="9" aria-label="Slide 10">
                        </button>
                    </div>

                    <button class="carousel-control-prev btn btn-icon-only rounded-circle" type="button"
                                    data-bs-target="#carouselExampleIndicators3" data-bs-slide="prev"
                                    style="margin-left: 20px; margin-bottom: 8px; background-color: transparent;">
                                    <i class="hp-text-color-dark-0 iconly-Light-ChevronLeftCircle" style="color: #9146ff;"></i>
                    </button>

                    <button class="carousel-control-next btn btn-icon-only rounded-circle" type="button"
                                    data-bs-target="#carouselExampleIndicators3" data-bs-slide="next"
                                    style="margin-right: 20px; margin-bottom: 8px; background-color: transparent;">
                                    <i class="hp-text-color-dark-0 iconly-Light-ChevronRightCircle" style="color: #9146ff;"></i>
                    </button>

                                
                </div>

            </div>

        </div>

        

            


        <!-- FOOTER -->
            <div class="divider mt-18 mb-16" style="padding-top: 30px;"></div>

            <div style="display: flex; justify-content: space-evenly; align-items: center; width: 100%;">
                

                <p class="hp-badge-text">
                    <a class="hp-badge-text" href="https://www.baesnap.com/privacy" target="_blank">Privacy</a>
                </p>

                <p class="hp-badge-text">•</p>

                <p class="hp-badge-text">
                    <a class="hp-badge-text" href="https://www.baesnap.com/terms" target="_blank">Terms</a>
                </p>

                <p class="hp-badge-text">•</p>

                <p class="hp-badge-text">
                    <a class="hp-badge-text" href="https://www.baesnap.com/complaints" target="_blank">Complaints</a>
                </p>

            </div>

        <div class="card hp-card-6 d-none" style="margin-bottom: -20px;" v-if=" !profilePic || !profileBack || !bio">
            <div class="card-body" style="padding-left: 10px; padding-right: 10px; ">
                
                <div class="position-absolute" style="left: 20px; bottom: 0px;">
                    <svg class="hp-stroke-color-dark-0" width="302" height="90" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M296 96.824 172.381 9l18.207 70.449-83.051-60.34L176.214 142 63.136 63.021l27.79 73.924L5 90.505"
                            stroke="#000000" stroke-width="20" stroke-linejoin="bevel"></path>
                    </svg>
                </div>

                <h4 style="text-align: start;" class="mb-16 hp-text-color-black-bg hp-text-color-dark-0"> Complete your
                    profile </h4>
                <p class="hp-p1-body hp-text-color-dark-0" style="font-size: 12px;"> Adding details about yourself helps
                    us tailor recommendations, show you relevant content, and ensure you get the most out of FanBayz.
                </p>

                <div class="divider mt-18 mb-16 "></div>

                <div class="row align-items-center justify-content-between" style="cursor: pointer;" @click="goProfile">

                    <div class="col" style="flex: 0.9 1 0%;">
                        <div class="row align-items-center">
                            <div class="col hp-flex-none w-auto">
                                <i class="hp-text-color-dark-0 ri-2 ri-user-3-line" style="font-size: 24px;"></i>
                            </div>

                            <div class="col flex-grow-1 pe-0">
                                <h6 class="mb-0">Profile picture</h6>

                                <p style="font-size: 12px;" class="hp-p1-body text-black-60 mb-0">Upload an image or gif
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col hp-flex-none w-auto">
                        <i class="ri-arrow-right-s-line" style="font-size: 24px;"></i>
                    </div>
                </div>

                <div class="row align-items-center justify-content-between mt-18" style="cursor: pointer;" @click="goProfile">

                    <div class="col" style="flex: 0.9 1 0%;">
                        <div class="row align-items-center">
                            <div class="col hp-flex-none w-auto">
                                <i class="hp-text-color-dark-0 ri-2 ri-image-2-line" style="font-size: 24px;"></i>
                            </div>

                            <div class="col flex-grow-1 pe-0">
                                <h6 class="mb-0">Profile Background</h6>

                                <p style="font-size: 12px;" class="hp-p1-body text-black-60 mb-0">Upload an image or gif
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col hp-flex-none w-auto">
                        <i class="ri-arrow-right-s-line" style="font-size: 24px;"></i>
                    </div>
                </div>

                <div class="row align-items-center justify-content-between mt-18" style="cursor: pointer;" @click="goProfile">

                    <div class="col" style="flex: 0.9 1 0%;">
                        <div class="row align-items-center">
                            <div class="col hp-flex-none w-auto">
                                <i class="hp-text-color-dark-0 ri-2 ri-chat-1-line" style="font-size: 24px;"></i>
                            </div>

                            <div class="col flex-grow-1 pe-0">
                                <h6 class="mb-0">Add bio</h6>

                                <p style="font-size: 12px;" class="hp-p1-body text-black-60 mb-0">Tell us a little bit
                                    about yourself
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col hp-flex-none w-auto">
                        <i class="ri-arrow-right-s-line" style="font-size: 24px;"></i>
                    </div>
                </div>

            </div>
        </div>

        <div class="card hp-card-6 d-none" >
            <div class="card-body">

                <div class="position-absolute" style="left: 20px; bottom: 0px;">
                    <svg class="hp-stroke-color-dark-0" width="302" height="90" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M296 96.824 172.381 9l18.207 70.449-83.051-60.34L176.214 142 63.136 63.021l27.79 73.924L5 90.505"
                            stroke="#000000" stroke-width="20" stroke-linejoin="bevel"></path>
                    </svg>
                </div>

                <h4 class="mb-32">Notifications</h4>

                <div v-if="notiList.length < 1" style="margin-top: 100px; margin-bottom: 100px; display: flex ; justify-content: center; align-items: center; flex-direction: column;">
                        <p class="hp-badge-text" id="emptySubText">No notifications yet...</p>
                </div>

                <ul class="timeline hp-p2-body">
                    <li class="timeline-item" v-for="noti in notiList" :key="noti.id">
                        <div class="timeline-item-tail" ></div>
                        <div class="timeline-item-head" ></div>
                        <div class="timeline-item-content" > @{{ noti.userName }} <span class="hp-p1-body hp-text-color-dark-0" style="margin-left: 5px;"> {{ noti.description }}</span></div>
                    </li>
                    
                </ul>

                

                

            </div>
        </div>

        <div class="card hp-card-4 d-none" >
            <div class="card-body">

                <div class="position-absolute" style="left: 20px; bottom: 0px;">
                    <svg class="hp-stroke-color-dark-0" width="302" height="90" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M296 96.824 172.381 9l18.207 70.449-83.051-60.34L176.214 142 63.136 63.021l27.79 73.924L5 90.505"
                            stroke="#000000" stroke-width="20" stroke-linejoin="bevel"></path>
                    </svg>
                </div>

                <h4 class="mb-32">Balance</h4>

                <h1>₦ {{ balanceD }}</h1>

                <div class="divider mt-18 mb-16 "></div>

                <button class="btn btn-primary mt-18" @click="goPayment">Top up</button>
                

            </div>
        </div>

        


    </div>

    <!-- SUCCESS -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="successModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 10px;">

                            <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ successText }}</p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;"
                                @click="closeS">Okay</button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ERROR -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg "
        ref="errorModal">

        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 30px;">

                            <h5 class="mt-24 mb-16 me-4 text-danger">Error!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ errorText }} </p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;"
                                @click="closeE">Okay</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- LOADING -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="loadingModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">

                        <div class="col-12 text-center">
                            <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;">
                        </div>

                        <div class="col-12 text-center">
                            <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ loadingText }} </p>

                            <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<style scoped>
    .card-overlay2 {
        background: rgba(0, 0, 0, 0.6);
        border-radius: 20px;
    }

    .card-overlay3 {
        background: rgba(0, 0, 0, 0.3);
        border-bottom-left-radius: 15px;
        border-bottom-right-radius: 15px;
    }

    .card-overlay4{

        background: rgba(255, 255, 255, 0.2);
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-bottom-left-radius: 15px;
        border-bottom-right-radius: 15px;

    }

    .xxsh{
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.29);
    }

    .navbarx ul {
    list-style-type: none; /* Removes default bullet points */
    margin: 0;
    padding: 0;
    width: 100%;
    display: flex; /* Aligns list items horizontally */
    justify-content: center; /* Centers the items in the navbar */
    background-color: #333;
    align-items: center;
}

.navbarx li a {
    display: block; /* Makes the whole area clickable */
    color: white;
    text-align: center;
    padding: 5px;
    width: 100%;
    text-decoration: none; /* Removes underlines from links */
}

/* Add a dot before each list item except the first one */
.navbarx li + li::before {
    content: "•"; /* The dot character (U+2022) or any other character like "|" */
    color: white; /* Color of the dot */
    padding: 0 5px; /* Space around the dot */
    line-height: 1.2; /* Adjust vertical alignment if necessary */
    width: 100%;
}

.navbarx li a:hover {
    background-color: #111; /* Hover effect */
}


</style>

<script>
import { doc,  collection, query, where, getDoc, getDocs, serverTimestamp, orderBy,  limit, updateDoc, Timestamp } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from '@/firebase';


export default {

    data() {

        return {

            loadingText: "",
            errorText: "",
            successText: "",

            profilePic: true,
            profileBack: true,
            bio: true,
            balance: "",
            balanceD: "",

            notiList: [],

            isOther: false,

            userType: "",

            featuredObj: "",
            featuredList: [],

            popularObj: "",
            popularList: [],

            newObj:"",
            newList: [],

        }

    },

    mounted() {

        this.getUserInfo();
        this.getNoti();
        this.getFeatured();
        this.getPopular();
        this.getNew();

    },

    methods: {

            // async pp(){

            //     const querySnapshot = await getDocs(collection(db, "Users"));
            //     querySnapshot.forEach((doc) => {
                
            //         this.assign2(String(doc.id));
                    
            //     });

            // },

            // async assign2(userId){

            //     const userRef = doc(db, "Users", userId);
            //     await updateDoc(userRef, {
                    
            //         refCode: "B"+ String(Math.floor(Math.random()*9000000000) + 1000000000),
            //         totalRefs: 0,
            //         refBalance: 0,
            //         upline: ""

            //     });

            //     console.log("DONE");

            // },

        closeE() {
            this.$refs.errorModal.classList.remove("bg-active");
        },

        closeS() {
            this.$refs.successModal.classList.remove("bg-active");
            this.$router.go();
        },

        detectMob() {
            return ( ( window.innerWidth <= 600 ) );
        },

        kFormatter(num) {
            return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num);

        },

        goProfile(){
            this.$router.push({name: 'profile'});
        },

        goNoti(){
            this.$router.push({name: 'notifications'});
        },

        goPayment(){
            this.$router.push({name: 'payments'});
        },

        async getUserInfo(){

            if(this.$route.name == "other-profile"){
                this.isOther = true;
            }

            if(sessionStorage.getItem("noUserName") == "noUserName"){
                return;
            }

            if(sessionStorage.getItem("profilePic").includes("api.dicebear.com")){
                this.profilePic = false;
            }

            if(sessionStorage.getItem("profileBackground").includes("defaultBack2")){
                this.profileBack = false;
            }

            if(sessionStorage.getItem("bio")==""){
                this.bio = false;
            }

            const auth = getAuth();
            const userRef = doc(db, "Users", auth.currentUser.uid);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {

                this.balance = userSnap.data().balance;

                if (this.balance == 0) {
                    this.balanceD = "0.00";
                }
                else {
                    this.balanceD = Number(userSnap.data().balance).toLocaleString("us-US");
                }

            }
            else {
                this.$router.push({ name: 'sign-in' });
                return;
            }


        },

        async getNoti(){

            const auth = getAuth();

            if(sessionStorage.getItem("noUserName") == "noUserName"){
                return;
            }

            const q = query(collection(db, "UserNoti"), where('ownerId', '==', auth.currentUser.uid), orderBy("date", "desc"), limit(5));
            const querySnapshot = await getDocs(q);

            if (querySnapshot.docs.length > 0) {

                querySnapshot.forEach((doc) => {

                    let a2 = String(new Date(Number(doc.data().date.seconds) * 1000));

                    this.notiList.push({

                        fullName: doc.data().fullName,
                        userName: doc.data().username,

                        id: doc.id,
                        description: doc.data().description,
                        
                        dateFull: a2.slice(0, -36),
                        dateD: a2.slice(0, -45),

                    })

                })

            }

        },

        profileClick(userId, userName) {

            const auth = getAuth();

            if (auth.currentUser.uid == userId) {
                this.$router.push({ name: 'profile' });
                return;
            }

            sessionStorage.setItem("otherId", userId);
            this.$router.push({ name: 'other-profile', params: { id: userName } });
            return;

        },

        async getFeatured(){

            if(this.detectMob()){
                return;
            }

            let tempList;
            let mFeaturedList = sessionStorage.getItem("featuredList");

            if(mFeaturedList != null && mFeaturedList != ""){
                const retrievedList = JSON.parse(mFeaturedList);
                this.getFeatured2(retrievedList);
                return;
            }

            const adminRef = doc(db, "AdminInfo", "info");
            const adminSnap = await getDoc(adminRef);

            if(adminSnap.exists()){
                tempList = adminSnap.data().featuredList
            }

            const listAsString = JSON.stringify(tempList);
            sessionStorage.setItem("featuredList", listAsString);

            this.getFeatured2(tempList);

        },

        async getFeatured2(tempList){

            for(let i = 0; i < tempList.length; i++){

                    const userRef = doc(db, "Users", tempList[i]);
                    const userSnap = await getDoc(userRef);

                    if(userSnap.exists()){

                        if(i == 0){
                            this.featuredObj = {

                                number: i,
                                id: userSnap.data().userId,
                                userId: userSnap.data().userId,
                                fullName: userSnap.data().name,
                                userName: userSnap.data().displayId, 
                                profilePic: userSnap.data().profilePic,
                                profileBackground: userSnap.data().profileBackground,
                                    
                                sexuality: userSnap.data().sexuality,
                                postCount: this.kFormatter(userSnap.data().postCount),
                                likes: this.kFormatter(userSnap.data().likes),
                                fanCount: this.kFormatter(userSnap.data().fanCount),
                                dateJoined: userSnap.data().dataJoined,
                                userType: userSnap.data().type

                            }
                        }

                        else{

                            this.featuredList.push({

                                number: i,
                                id: userSnap.data().userId,
                                userId: userSnap.data().userId,
                                fullName: userSnap.data().name,
                                userName: userSnap.data().displayId, 
                                profilePic: userSnap.data().profilePic,
                                profileBackground: userSnap.data().profileBackground,
                                    
                                sexuality: userSnap.data().sexuality,
                                postCount: this.kFormatter(userSnap.data().postCount),
                                likes: this.kFormatter(userSnap.data().likes),
                                fanCount: this.kFormatter(userSnap.data().fanCount),
                                dateJoined: userSnap.data().dataJoined,
                                userType: userSnap.data().type

                            })

                        }

                        

                    }
            }

        },

        async getPopular(){

            if(this.detectMob()){
                return;
            }

            // let mPopularList = sessionStorage.getItem("popularList");

            // if(mPopularList == null || mPopularList == ""){
                
            // }
            // else{
            //     const retrievedList = JSON.parse(mPopularList);
            //     this.popularList = retrievedList;
            //     return;
            // }

            const q = query(collection(db, "Users"), where("type", '==', "model"), orderBy("fanCountN"), limit(8));
            const querySnapshot = await getDocs(q);

            let i = -1;

            if (querySnapshot.docs.length > 0){

                querySnapshot.forEach((doc) => {

                    i++

                    if(i == 0){
                        this.popularObj = {

                            number: i,
                            id: doc.data().userId,
                            userId: doc.data().userId,
                            fullName: doc.data().name,
                            userName: doc.data().displayId, 
                            profilePic: doc.data().profilePic,
                            profileBackground: doc.data().profileBackground,
                                    
                            sexuality: doc.data().sexuality,
                            postCount: this.kFormatter(doc.data().postCount),
                            likes: this.kFormatter(doc.data().likes),
                            fanCount: this.kFormatter(doc.data().fanCount),
                            dateJoined: doc.data().dataJoined,
                            userType: doc.data().type

                        }
                    }
                    else{

                        this.popularList.push(
                            {

                                number: i,
                                id: doc.data().userId,
                                userId: doc.data().userId,
                                fullName: doc.data().name,
                                userName: doc.data().displayId, 
                                profilePic: doc.data().profilePic,
                                profileBackground: doc.data().profileBackground,
                                        
                                sexuality: doc.data().sexuality,
                                postCount: this.kFormatter(doc.data().postCount),
                                likes: this.kFormatter(doc.data().likes),
                                fanCount: this.kFormatter(doc.data().fanCount),
                                dateJoined: doc.data().dataJoined,
                                userType: doc.data().type

                            }
                        )

                    }

                    

                })

                //let mPopularList = this.popularList.unshift(this.popularObj);
                //save list
                // const listAsString = JSON.stringify(this.popularList);
                // sessionStorage.setItem("popularList", listAsString);
                

            }

        },

        async getNew(){

            if(this.detectMob()){
                return;
            }

            // let mNewList = sessionStorage.getItem("newList");

            // if(mNewList == null || mNewList == ""){
                
            // }
            // else{
            //     const retrievedList = JSON.parse(mNewList);
            //     this.newList = retrievedList;
            //     return;
            // }

            const thirtyDaysAgo = new Date();
            thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 50);
            const thirtyDaysAgoTimestamp = Timestamp.fromDate(thirtyDaysAgo);

            const q = query(collection(db, "Users"), where("type", '==', "model"), where("dateJoined", '>', thirtyDaysAgoTimestamp), orderBy("dateJoinedN"), limit(8));
            const querySnapshot = await getDocs(q);

            let i = -1;

            if (querySnapshot.docs.length > 0){

                querySnapshot.forEach((doc) => {

                    i++

                    if(i == 0){
                        this.newObj = {

                            number: i,
                            id: doc.data().userId,
                            userId: doc.data().userId,
                            fullName: doc.data().name,
                            userName: doc.data().displayId, 
                            profilePic: doc.data().profilePic,
                            profileBackground: doc.data().profileBackground,
                                    
                            sexuality: doc.data().sexuality,
                            postCount: this.kFormatter(doc.data().postCount),
                            likes: this.kFormatter(doc.data().likes),
                            fanCount: this.kFormatter(doc.data().fanCount),
                            dateJoined: doc.data().dataJoined,
                            userType: doc.data().type

                        }
                    }
                    else{

                        this.newList.push(
                            {

                                number: i,
                                id: doc.data().userId,
                                userId: doc.data().userId,
                                fullName: doc.data().name,
                                userName: doc.data().displayId, 
                                profilePic: doc.data().profilePic,
                                profileBackground: doc.data().profileBackground,
                                        
                                sexuality: doc.data().sexuality,
                                postCount: this.kFormatter(doc.data().postCount),
                                likes: this.kFormatter(doc.data().likes),
                                fanCount: this.kFormatter(doc.data().fanCount),
                                dateJoined: doc.data().dataJoined,
                                userType: doc.data().type

                            }
                        )

                    }

                    //let mNewList = this.newList.unshift(this.newObj);
                    //save list
                    // const listAsString = JSON.stringify(this.newList);
                    // sessionStorage.setItem("newList", listAsString);

                })

            }

        }


    }

}
</script>